// extracted by mini-css-extract-plugin
export default {"primary":"#ea5a17","secondary":"#5eb1bf","tertiary":"#fcebd8","white":"#f8f9fa","black":"#042a2b"};